"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Error = _interopRequireDefault(require("@material-ui/icons/Error"));

var _WarningRounded = _interopRequireDefault(require("@material-ui/icons/WarningRounded"));

var _CheckCircle = _interopRequireDefault(require("@material-ui/icons/CheckCircle"));

var _Info = _interopRequireDefault(require("@material-ui/icons/Info"));

var _makeStyles = _interopRequireDefault(require("../styles/makeStyles"));

var _lab = require("@material-ui/lab");

var _excluded = ["className", "variant", "color", "iconMapping", "severity"];

// Font colors for filled are not adjustable in MUI, so we will have to adjust it ourselves
var styles = function styles(theme) {
  return {
    root: {
      boxShadow: theme.shadows[2],
      fontSize: theme.spacing(2)
    },
    filled: {
      fontWeight: 'normal'
    },
    filledWarning: {
      color: theme.palette.warning.text
    }
  };
};

exports.styles = styles;
var useStyles = (0, _makeStyles["default"])(styles);
var internalIconMapping = {
  success: /*#__PURE__*/_react["default"].createElement(_CheckCircle["default"], {
    fontSize: "inherit"
  }),
  warning: /*#__PURE__*/_react["default"].createElement(_WarningRounded["default"], {
    fontSize: "inherit"
  }),
  error: /*#__PURE__*/_react["default"].createElement(_Error["default"], {
    fontSize: "inherit"
  }),
  info: /*#__PURE__*/_react["default"].createElement(_Info["default"], {
    fontSize: "inherit"
  })
};
/**
 * An alert displays a short, important message in a way that attracts the user's attention without interrupting the user's task.
 */

var Alert = function Alert(_ref) {
  var className = _ref.className,
      variant = _ref.variant,
      color = _ref.color,
      iconMapping = _ref.iconMapping,
      severity = _ref.severity,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classes = useStyles({
    variant: variant
  });
  return /*#__PURE__*/_react["default"].createElement(_lab.Alert, (0, _extends2["default"])({
    className: (0, _classnames["default"])(className, classes.root, (0, _defineProperty2["default"])({}, classes.filledWarning, variant === 'filled' && color === 'warning'), (0, _defineProperty2["default"])({}, classes.filled, variant === 'filled')),
    iconMapping: iconMapping || internalIconMapping,
    color: color,
    variant: variant,
    severity: severity
  }, rest));
};

var _default = Alert;
exports["default"] = _default;